@if (!isPda()) {
  <div id="ic-main-container" [class.pinned-container]="panelPinned() && !isSmallDesktop()">
    <div id="ic-main-header">
      <ic-header [user]="currentUser()" [userFailed]="currentUserFailed()"></ic-header>
    </div>
    <div id="ic-main-content-wrapper">
      <ic-sidebar
        [isSidebarOpen]="panelOpen()"
        [isPinned]="panelPinned()"
        [user]="currentUser()"
        (isOpenChange)="panelOpen.set($event)"
        (isPinnedChange)="panelPinned.set($event)"
        >
      </ic-sidebar>
      <div id="ic-main-content" [class.pinned]="panelPinned() && !isSmallDesktop()">
        <router-outlet #o="outlet"></router-outlet>
      </div>
    </div>
  </div>

  <!-- Off unless the environment has a flow URL. Waits for the user, whose details it sends, and loads its own chunk once the page is idle.
       The prompt (ER-1612) is the occasional modal that asks for feedback; it rides the same switch, in a chunk of its own. -->
  @if (feedbackEnabled && currentUser()) {
    @defer (on idle) {
      <ic-feedback-widget></ic-feedback-widget>
    }
    @defer (on idle) {
      <ic-feedback-prompt></ic-feedback-prompt>
    }
  }
}

@if (isPda()) {
  <div>
    <router-outlet #o="outlet"></router-outlet>
  </div>
}


